const SortHeader: React.FC = ({ children }) => {
  return (
    <ul className="w3-ul">
      <div className="w3-cell-row w3-margin-bottom">{children}</div>
    </ul>
  );
};

export default SortHeader;
